import { render, staticRenderFns } from "./unionPrice.vue?vue&type=template&id=094ff6d8&"
import script from "./unionPrice.vue?vue&type=script&lang=js&"
export * from "./unionPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports